import { ApiEndPoint } from '@/domains/api/api.entity';
import type { StudentApiResponse } from '@/domains/students/student.entity';
import { apiRequest } from './apiRequest';

/**
 * Implementación de la lógica para llamar al API de estudiante
 */
class StudentApiService {
  /**
   * Obtención de lista completa de estudiantes desde el endpoint
   */
  async getStudentAll(): Promise<StudentApiResponse> {
    /**
     * GET para obtener lista completa de estudiantes
     * El filtrado por año/semestre se hará en el frontend
     */
    const studentResponse = await apiRequest.get<StudentApiResponse>({
      route: ApiEndPoint.STUDENT,
    });

    return studentResponse;
  }
}

export const studentApiService = new StudentApiService();
